import React, { Component } from 'react';
import store from '../../store';
import { ShowPagination, GetPageParameter } from '../../component/ShowPagination';
import { HandleSubmit } from '../../func/HandleSubmit';
import Autocomplete from 'react-autocomplete';
import '../../component/AutoComplete.css'
import { matchStateToTerm, sortStates } from '../../component/AutoCompleteFunc'
import matchSorter from 'match-sorter'
import ReactTable from 'react-table-6'
import "react-table-6/react-table.css";
import Select from 'react-select';
var RowInPageParam = 20
class TableOfKalaInventory extends Component {
    reqest_number = "";
    constructor(props) {
        super(props);
        this.state = {
            TableOfInventory: [],
            SearchItems: [],
            TableRow: [],
            Loading: true,
            SelectPage: 0,
            RowInPage: RowInPageParam,
            InventoryCounter: 0,
            ShowDetailKalaWorkflow: [],
            SendParameters: {
                kala_name: { kala_name: '' },
                limit: RowInPageParam,
                offset: 0,/////request per page
            }
        };
        this.GetTableOfInventoryByName = this.GetTableOfInventoryByName.bind(this);
        this.InitParameter = this.InitParameter.bind(this);
        this.GetKalaName = this.GetKalaName.bind(this);
        this.SetParameterValueByName = this.SetParameterValueByName.bind(this);

    }
    async SetParameterValueByName(name, value) {
        this.state.SendParameters['kala_name'] = { ...this.state.SendParameters['kala_name'], [name]: value };
        this.setState({
            SendParameters: this.state.SendParameters,
        });
        //console.log("qqq", this.state.SendParameters);
    }
    async GetKalaName() {
        this.setState({
            Loading: true
        });
        var response_info = await HandleSubmit('getdata/getkalaname', '');
        this.setState({
            SearchItems: (response_info),
        });
        this.setState({
            Loading: false
        });
    }

    async GetTableOfInventoryByName() {
        this.setState({
            Loading: true
        });
        //var response = await HandleSubmit('kala/report', this.state.SendParameters);
        var response = await HandleSubmit('kala/reportwithoutfilter', this.state.SendParameters);
        this.setState({
            TableOfInventory: (response).items,
            InventoryCounter: (response).record_count
        });
        for (let i = 0; i < (response).record_count; i++) {
            this.state.ShowDetailKalaWorkflow[i] = false;
        }
        //await this.CreateRow();
        this.setState({
            Loading: false
        });
    }
    async InitParameter() {
        this.state.SendParameters.limit = this.state.RowInPage;
        this.state.SendParameters.offset = 0;
        this.setState({
            SelectPage: 0,
            SendParameters: this.state.SendParameters,
        });
        await this.GetTableOfInventoryByName();

    }
    async componentDidMount() {
        store.dispatch({ type: 'reportkala' });
        //await this.GetTableOfInventoryByName();
        await this.GetKalaName();
        await this.InitParameter();

    }
    componentWillReceiveProps() {
        this.setState({
            SubPage: this.props.subpage
        });
    }
    render() {
        if (this.state.Loading === true) return (<div>Loading....</div>)
        return (
            <React.Fragment>
                <div style={{
                    fontSize: "24px",
                    color: "red",
                    border: "3px solid rgba(0, 150, 255, 0.91)",
                    borderRadius: "10px",
                }}>گزارش گردش کالا</div>
                <ReactTable
                    className="-striped -highlight"
                    filterable
                    SubComponent={(row) => (<ListOfKalaWorkflow KalaCode={row.original.kala_code} AnbarCode={row.original.anbar_code} />)}
                    headerStyle={{ fontWeight: "bold", fontcolor: "red" }}
                    data={this.state.TableOfInventory}
                    columns={[
                        {
                            expander: true,
                            width: 100,
                            //minWidth: 200,
                            Expander: ({ isExpanded, ...rest }) => {
                                return (
                                    <div>{isExpanded ? <span><button >-</button></span> : <span><button>+</button></span>}</div>
                                );

                            }
                        },
                        {
                            Header: "#",
                            accessor: "row",
                            maxWidth: 100,
                            minWidth: 20
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}> کد کالا </div>,
                            //Header:()=><h1>Name</h1>,
                            accessor: "kala_code",
                            filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["kala_code"] }),
                            filterAll: true
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}> نام کالا </div>,
                            //Header: " نام کالا",
                            accessor: "kala_name",

                            filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, { keys: ["kala_name"] }),
                            filterAll: true
                            // filterMethod: (filter, row) => (
                            //     row[filter.id].startsWith(filter.value) && row[filter.id].endsWith(filter.value)),

                            // accessor: d => d.lastName

                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}>انبار </div>,
                            accessor: "anbar_name",
                            Filter: ({ filter, onChange }) =>
                                <select
                                    onChange={event => onChange(event.target.value)}
                                    style={{ width: "100%" }}
                                    value={filter ? filter.value : "all"}
                                >
                                    <option value="">نمایش همه</option>
                                    <option value="انبار ورامین">انبار ورامین</option>
                                    <option value="انبار فیروزآباد">انبار فیروزآباد</option>
                                </select>
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}>موجودی انبار </div>,
                            accessor: "kala_inventory_stock"
                        }
                    ]
                    }
                    defaultPageSize={20}
                    className="-striped -highlight"

                />

            </React.Fragment>
        );
    }
}
export default (TableOfKalaInventory);

class ListOfKalaWorkflow extends Component {
    myRef = [];
    constructor(props) {
        super(props);
        this.state = {
            SendParameters: { kala_code: this.props.KalaCode, anbar_code: this.props.AnbarCode },
            TableRow: [],
            Loading: true,
        };
        // this.refreshComponent = this.props.refreshComponent.bind(this);
    }
    async initComponent() {
        this.setState({
            Loading: true,
        });
        await this.GetListOfRow();
        this.CreateRow();
        this.setState({
            Loading: false,
        });
    }
    async GetListOfRow() {

        this.setState({
            TableRow: [],
        });
        let response_info = await HandleSubmit('kala/reportkalaworkflow', this.state.SendParameters);
        this.setState({
            TableOfProgress: response_info.items,
        });
        //console.log("sad", response_info);
        // console.log("last", response_info.items[response_info.items.length - 1].kala_qty);
    }
    CreateRow() {
        let counter = 0;
        var qty = 0;
        //var remain = 0;

        //var remain = this.state.TableOfProgress[this.state.TableOfProgress.length - 1].kala_qty;
        for (let item of this.state.TableOfProgress) {
            // remain = item.progress_status == '+' ? parseInt(item.kala_qty) + (remain) : remain - parseInt(item.kala_qty);
            this.state.TableRow.push({
                Row: <React.Fragment>
                    <td>{counter + 1}</td>
                    <td>{item.request_code}</td>
                    <td>{item.progress_date}</td>
                    <td>{item.kala_qty}</td>
                    <td>{item.progress_status}</td>
                    <td>{item.remain}</td>
                </React.Fragment >
            });
            //this.state.show_view_row[item.row] = false;
            counter++;
            qty = parseInt(item.kala_qty);
        }
        this.setState({
            TableRow: this.state.TableRow,
            //show_rem_row: this.state.show_rem_row
        });

    }
    async componentDidMount() {
        this.initComponent();
    }
    async componentWillReceiveProps() {
        this.initComponent();
    }
    render() {
        //console.log(this.state.SendParameters.detail);
        //if (this.state.Loading) { return "در حال بارگزاری..."; }
        return (
            <div>
                <div> کد کالا{this.state.SendParameters.kala_code}</div>
                <table className="table-responsive table-bordered table-striped" style={{ "textAlign": "center", "border": "4px solid rgba(0, 150, 255, 0.91)" }}>
                    <tbody>
                        <tr>
                            <th>#</th>
                            <th>شماره سفارش</th>
                            <th>تاریخ</th>
                            <th>تعداد</th>
                            <th>وضعیت</th>
                            <th>مانده</th>
                        </tr>
                        {this.state.TableRow.map(
                            (item, index) => (
                                <React.Fragment key={index}>
                                    <tr>{item.Row}</tr>
                                </React.Fragment>
                            )
                        )}
                    </tbody>
                </table>
            </div >
        );
    }

}



// WEBPACK FOOTER //
// ./src/pages/Kala/ReportKala.js